module.exports = __webpack_public_path__ + "static/media/pin.4b77212b.svg";